<div class="breadcrumb-wrapper">
  <ul>
    @for (menu of uiMenuItemArray; track menu; let i = $index) {
      <li>
        <a (click)="breadCrumbClick(menu,i)" class="cursor-pointer"><span [innerHTML]="menu.name | fnTranslate" ></span></a>
      </li>
    }
   <li *ngIf="uiMap.isShowCustomMenu">
        <a class="cursor-pointer"><span> {{uiMap.customMenuText}}</span></a>
    </li>
  </ul>
</div>
